import { SchoolService, BaseService } from "@/services/school.service";

const SwimmingService = {
    getOutcomesByAward(awardId) {
        return SchoolService.getAll("swimming/awards/" + awardId + "/outcomes")
    },



    // GRADES
    getGradesByAward(awardId) {
        return SchoolService.getAll("swimming/awards/" + awardId + "/grades")
    },

    addGrade(payload) {
    	return SchoolService.create("swimming/grades", payload)
    },

    deleteGrade(result) {
    	return SchoolService.delete("swimming/grades", result.identifier, null)
    },
     
}

export { SwimmingService };
